import { useEffect, useState } from "react";
import { getInstrumentSharePrice } from "../services";
import { getDateParam } from "../utils";
import { resolveMinimumSharePrice } from "../utils/amountInvestedValidation";
import { useDispatch } from "react-redux";
import { updateSelectedInstrumentMinimumPrice } from "../store/slice/trade";

export const useMinimumSharePrice = ({ instrumentId, startDate, endDate, currency }) => {
  const [minimumPrice, setMinimumPrice] = useState(0);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!instrumentId || !startDate || !endDate) return;

    let cancelled = false;

    const fetchMinimumPrice = async () => {
      setLoading(true);
      try {
        const response = await getInstrumentSharePrice({
          instrumentId,
          startDate: getDateParam(startDate),
          endDate: getDateParam(endDate),
          currency: currency || "",
        });
        if (cancelled) return;
        const data = response?.data?.instrumentSharePrice;
        if (data) {
          const minimumSharePrice = resolveMinimumSharePrice(data);
          setMinimumPrice(minimumSharePrice);
          dispatch(updateSelectedInstrumentMinimumPrice(minimumSharePrice));
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchMinimumPrice();

    return () => {
      cancelled = true;
    };
    // Fetch only when instrument, Date of Investment, or currency changes — NOT on endDate
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instrumentId, startDate, currency]);

  return { minimumPrice, loading };
};
